<!--活动表单-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            {{ form.id ? form.name + "--------" + "id：" + form.id : "添加系统参数" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="5rem" class="pb-6">
                <el-form-item label="名称">
                    <el-input v-model="form.name" autocomplete="off" clearable>
                    </el-input>
                </el-form-item>
				<el-form-item label="信息">
				    <el-input
				        v-model="form.info"
				        type="textarea"
				        :autosize="{ minRows: 2, maxRows: 10 }"
				        clearable
				    ></el-input>
				</el-form-item>
				<el-form-item label="所属平台" v-if="role === 0">
				    <select-platform
				    	@choose="choosePlatformId"
				        :selectPlatform="form.platform_id"
				        :width="'100%'"
				    />
				</el-form-item>
				<div align="center">
					<h4 class="mb-3">整型</h4>
					<el-form-item label="1">
					    <el-input v-model="form.integer1" type="number" autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
					<el-form-item label="2">
					    <el-input v-model="form.integer2" type="number" autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
					<el-form-item label="3">
					    <el-input v-model="form.integer3" type="number" autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
					<el-form-item label="4">
					    <el-input v-model="form.integer4" type="number" autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
					<el-form-item label="5">
					    <el-input v-model="form.integer5" type="number" autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
				</div>
				<v-divider inset class="pt-3 pb-3"></v-divider>
				<div align="center">
					<h4 class="mb-3">字符型</h4>
					<el-form-item label="1">
					    <el-input v-model="form.str1" type="textarea" autosize autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
					<el-form-item label="2">
					    <el-input v-model="form.str2" type="textarea" autosize autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
					<el-form-item label="3">
					    <el-input v-model="form.str3" type="textarea" autosize autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
					<el-form-item label="4">
					    <el-input v-model="form.str4" type="textarea" autosize autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
					
					<el-form-item label="5">
					    <el-input v-model="form.str5" type="textarea" autosize autocomplete="off" clearable>
					    </el-input>
					</el-form-item>
				</div>
            </el-form>
			<!-- <json-viewer :value="JSON.parse(form.str5)" ></json-viewer> -->
			<vue-json-editor
				v-model="resultInfo"
				:showBtns="false"
				:mode="'code'"
				:expanded-on-start="true"
				@json-change="onJsonChange"
				@json-save="onJsonSave"
				@has-error="onError"
				style="height: 300px;"
			/>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { mapState } from "vuex";
import util from "@/util";
import Public from "@/public"
import store from "@/store";
import vueJsonEditor from 'vue-json-editor'
import SelectPlatform from "@/components/SelectPlatform";
export default {
    name: "ICForm",
	components: { 
		vueJsonEditor,
		SelectPlatform
	},
    data() {
        return {
			hasJsonFlag:true,  // json是否验证通过
			resultInfo: [],
            form: {
                id: null,
				name: null,
				info: null,
				platform_id: null,
				integer1: null,
				integer2: null,
				integer3: null,
				integer4: null,
				integer5: null,
				str1: null,
				str2: null,
				str3: null,
				str4: null,
				str5: null
            },
        };
    },
    props: {
        isAdd: Boolean,
		systemData: Object
    },
    mounted() {
    	Object.keys(this.form).forEach(key => {
    	    this.form[key] = this.systemData[key];
    	});
		if(this.form.str5) {
			this.resultInfo = JSON.parse(this.form.str5)
		}
    },
    computed: {
        ...mapState(["theme", "couponInfos","role"]),
    },
    methods: {
		// json改变时，触发的事件
		onJsonChange (value) {
			// console.log('更改value:', value);
			this.form.str5 = JSON.stringify(value)
			// 实时保存
			this.onJsonSave(value)
		},
		 // json保存事件
		onJsonSave (value) {
			this.resultInfo = value
			this.hasJsonFlag = true
		},
		 // 出现错误时，触发的事件
		onError(value) {
			// console.log("json错误了value:", value);
			this.hasJsonFlag = false
		},
		/*选择平台*/
		choosePlatformId(e) {
			// console.log(e)
			this.form.platform_id = e
		},
        /*确定*/
        determine() {
			let form = Object.assign({}, this.form);
			Object.keys(form).forEach(key => {
				if(key == 'integer1' || key == 'integer2' || key == 'integer3'|| key == 'integer4'|| key == 'integer5') {
					if((typeof form[key]) == 'string' && form[key].length == 0 ){
						form[key] = NaN;
					}else {
						form[key] = Number(form[key])
					}
				}
				if(key == 'str1' || key == 'str2' || key == 'str3'|| key == 'str4'|| key == 'str5') {
				    // delete form[key];
					form[key] = Public.removeSpace(form[key])
					if(!form[key]) {
						form[key] = null;
					}
				}
				if(key == "name" || key == "info") {
					form[key] = Public.removeSpace(form[key])
				}
			});
            let params = {
                postData: {
					system_param: form,
				},
                callbackOk: () => {
                    this.$emit("refresh");
                    this.cancel();
                },
            };
			console.log(form)
            if (this.isAdd) {
                store.dispatch("addSystem", params);
            } else {
                store.dispatch("updateSystem", params);
            }
        },
        /*取消*/
        cancel() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = null;
            });
            this.$emit("cancel");
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
<style lang="scss" scoped>
/* jsoneditor右上角默认有一个链接,加css去掉 */
::v-deep .jsoneditor-poweredBy {
	display: none !important;
	opacity: 0;
}
</style>
